import { css } from "@emotion/react"
import { forwardRef } from "react"

type ToggleButtonProps = {
  active: boolean
  children: React.ReactNode
  name: string
  onClick?: () => void
}

export const ToggleButton = forwardRef<
  HTMLLabelElement,
  ToggleButtonProps & React.HTMLAttributes<HTMLLabelElement>
>(function ToggleButton(
  { active, children, name, onClick, className, ...props },
  ref,
) {
  return (
    <label
      {...props}
      className={`p-r d-ib p-0${className ? ` ${className}` : ""}`}
      css={css`
        cursor: pointer;
      `}
      ref={ref}
    >
      <input
        type="radio"
        name={name}
        checked={active}
        onChange={() => onClick?.()}
        className="visually-hidden"
      />
      <span
        className="btn text-btn w-100%@md"
        css={[
          toggleButtonStyles.button,
          toggleButtonStyles.buttonFocus,
          active && toggleButtonStyles.buttonActive,
        ]}
      >
        {children}
      </span>
    </label>
  )
})

export const toggleButtonStyles = {
  button: css`
    background: var(--d-fill-color-chip);
    border: 1px solid var(--d-border-color-chip);
    border-radius: 1.5rem;
    color: var(--d-text-color-chip);
    padding-inline: 1rem;
  `,
  buttonActive: css`
    background: transparent;

    @supports (background: hsl(from white h s l)) {
      background: hsl(
        from var(--d-fill-color-chip-selected) h s
          var(--d-hsl-lightness-chip-selected)
      );
    }

    border-width: 2px;
    border-color: var(--d-border-color-chip-selected);
    color: var(--d-text-color-chip-selected);
    font-weight: 500;
  `,
  buttonFocus: css`
    input[type="radio"]:focus-visible + & {
      box-shadow:
        inset 0 0 0 1px var(--d-fill-color-neutral-100),
        inset 0 0 0 3px var(--d-focus-ring-color);
    }
  `,
}
